<template>
  <div>
    <CustomLoader v-if="isLoading" :width="70" />

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark" variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Additional Task Request (Lite)</b-navbar-brand>
        </b-navbar>

        <banner-component
          :allModuleIdBanner="$sessionsStorage.get('allModuleIdMain') || ''"
          :jobSeriesBanner="$sessionsStorage.get('JOBSERIES') || ''"
          iconId="fa fa-ship"
        />

        <b-card class="formCard mt-2">
          <b-card-text>
            <!-- Assignment Details -->
            <b-card class="mt-2">
              <h5>
                <b-badge variant="info">Assignment Details</b-badge>
              </h5>
              <table class="table table-bordered table-sm gutr mt-1 mb-1">
                <tbody>
                  <tr>
                    <th>Job No.</th>
                    <th>Job Date</th>
                    <th>Client Name</th>
                    <th>POD</th>
                  </tr>
                  <tr v-for="(item, index) in assignmentRows" :key="index">
                    <td class="error" style="font-size: 14px"><h6>{{ item.Job_Series }}</h6></td>
                    <td class="error" style="font-size: 14px"><h6>{{ item.JobDate }}</h6></td>
                    <td class="error" style="font-size: 14px"><h6>{{ item.clientName }}</h6></td>
                    <td class="error" style="font-size: 14px"><h6>{{ item.POD }}</h6></td>
                  </tr>
                </tbody>
              </table>
              

              <!-- Additional Task Details -->
              <h5>
                <b-badge variant="info">Additional Task Details</b-badge>
              </h5>
              <div class="table-responsive table-container mt-1 mb-1">
              <table class="table table-sm table-bordered table-hover gutr table-sticky">
                <thead class="thead-light">
                  <tr>
                    <th style="min-width: 120px; width:120px;" class="text-right">
                      <b-button
                        id="add-row-btn"
                        size="sm"
                        variant="success"
                        :disabled="assignmentData[0] && assignmentData[0].Job_Series !== $sessionsStorage.get('JOBSERIES')"
                        @click="addInvArry"
                      >
                        <i class="fa fa-plus mr-1"></i> Add
                      </b-button>
                    </th>
                    <th style="width: 60px">SN.</th>
                    <th style="min-width: 220px">Particulars</th>
                    <th style="min-width: 110px; width:110px;">Exp Amount</th>
                    <th style="min-width: 110px; width:110px;">Currency</th>
                    <th style="min-width: 160px">Bill To Customer</th>
                    <th style="min-width: 140px">Selling AMT</th>
                    <th style="min-width: 150px">Approval Status</th>
                    <th style="min-width: 220px">Remarks</th>
                   
                  </tr>
                </thead>
                <tbody style="background: white">
                  <tr v-if="!lineADDTaskModalArray.length">
                    <td colspan="9" class="text-center text-muted py-3">
                      No additional tasks yet. Click <strong>Add</strong> to create a row.
                    </td>
                  </tr>
                  <AddTaskRow
                    v-for="(itm, idx) in lineADDTaskModalArray"
                    :key="idx"
                    :item="itm"
                    :index="idx"
                    :ledgerData="$store.getters['common/getAllLedgerList']"
                    :scCategoryList="SCCategoryList"
                    :isAdminRemovable="isAdminRemovable"
                    :currencies="currencies"
                    @remove="removeInvArry"
                    @remove-admin="removeAdditionalTask"
                    @alert="showAlert"
                    @change="onRowChange"
                  />
                </tbody>
                <tfoot v-if="lineADDTaskModalArray.length">
                  <tr class="bg-light font-weight-bold">
                    <td colspan="2" class="text-right">Totals:</td>
                    <td>{{ totalExpense }}</td>
                    <td></td>
                    <td></td>
                    <td>{{ totalSelling }}</td>
                    <td></td>
                    <td>
                      <b-badge :variant="netMargin >= 0 ? 'success' : 'danger'">Margin: {{ netMargin }}</b-badge>
                    </td>
                    <td class="text-right pr-3">Rows: {{ lineADDTaskModalArray.length }}</td>
                  </tr>
                </tfoot>
              </table>
              </div>
            </b-card>

            <b-row>
              <b-col lg="5"></b-col>
              <b-col lg="2">
                <b-button
                  v-if="lineADDTaskModalArray.length > 0"
                  class="mt-3 d-flex align-items-center justify-content-center"
                  size="sm"
                  variant="primary"
                  :disabled="isSubmitting || (assignmentData[0] && assignmentData[0].Job_Series !== $sessionsStorage.get('JOBSERIES'))"
                  @click="addADDTaskDetail"
                >
                  <b-spinner small class="mr-2" v-if="isSubmitting"></b-spinner>
                  <span>Save & Submit</span>
                </b-button>
              </b-col>
              <b-col lg="5"></b-col>
            </b-row>
          </b-card-text>
        </b-card>

        <!-- Old & New Additional Tasks Section -->
        <OldExpenseAdditionalTask
          v-if="$sessionsStorage.get('allModuleIdMain')"
          :allModuleId="$sessionsStorage.get('allModuleIdMain')"
          type="additional-task"
        />

        <md-dialog-confirm :md-content-html="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-confirm>
        <md-dialog-confirm 
          :md-content-html="confirmDelete.content" 
          :md-ok-text="confirmDelete.ok" 
          :md-cancel-text="confirmDelete.cancel"
          @close="onCloseDeleteConfirm"
          ref="addPopDelete">
        </md-dialog-confirm>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import AddTaskRow from './components/AddTaskRow.vue'
import CustomLoader from '../common/customLoader.vue'
import BannerComponent from './bannerComponent.vue'
import OldExpenseAdditionalTask from './components/OldExpenseAdditionalTask.vue'
// import { URL_BASE } from '../../helper/constant.js'
import PaymentRequestService from '../../services/PaymentRequestService.js'
import { GlobalGetCurrencies, GlobalGetPurchaseExpense } from '../../helper/collection'
import { mapNodePurchaseExpenseToAddTaskRow, PaymentTypes } from '../../helper/PaymentHelper.js'

export default {
  name: 'AdditionalTaskLite',
  components: { AddTaskRow, CustomLoader, BannerComponent, OldExpenseAdditionalTask },
  data() {
    return {
      isLoading: false,
      isSubmitting: false,
      alert: { content: 'Added Successfully', ok: 'ok' },
      confirmDelete: {
        content: 'Are you sure you want to remove this additional task? This action cannot be undone.',
        ok: 'Yes, Remove',
        cancel: 'Cancel',
      },
      itemToDelete: null,
      assignmentData: [],
      ledgerData: [],
      currencies: [],
      lineADDTaskModalArray: [],
      SCCategoryList: [
        { SCVal: 'Yes', SCText: 'Yes' },
        { SCVal: 'No', SCText: 'No' },
      ],
      ADDTaskDetail: {
        revisedMail: '0',
        ape_id: '',
        allModuleId: '',
        salesExeuctionNo: '',
      },
    }
  },
  computed: {
    isAdminRemovable() {
      return this.$sessionsStorage.get('designation') === 'Admin' && this.$sessionsStorage.get('nameUser') === 'Bhavneesh'
    },
    // Fallback: show minimal assignment details when no API data available
    assignmentRows() {
      if (Array.isArray(this.assignmentData) && this.assignmentData.length > 0) return this.assignmentData
      return [
        {
          Job_Series: this.$sessionsStorage.get('JOBSERIES') || '-',
          JobDate: this.$sessionsStorage.get('JOBDATE') || '-',
          clientName: this.$sessionsStorage.get('CLIENTNAME') || '-',
          POD: this.$sessionsStorage.get('POD') || '-',
        },
      ]
    },
    totalExpense() {
      try {
        return this.lineADDTaskModalArray
          .map((r) => Number(r.addTask_amount) || 0)
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      } catch (e) {
        return 0
      }
    },
    totalSelling() {
      try {
        return this.lineADDTaskModalArray
          .map((r) => (r.addTask_scCategory === 'Yes' ? Number(r.addTask_selling_amt) || 0 : 0))
          .reduce((a, b) => a + b, 0)
          .toFixed(2)
      } catch (e) {
        return 0
      }
    },
    netMargin() {
      return (Number(this.totalSelling) - Number(this.totalExpense)).toFixed(2)
    },
  },
  beforeMount() {
    if (this.$sessionsStorage.get('allModuleIdMain') && this.$sessionsStorage.get('JOBSERIES') !== '') {
      // Populate Ledger List in store similar to airCCTPTInvoice
      this.$store.dispatch(
        'common/setAllLedgerList',
        JSON.stringify({
          itemCode: 'LedgerList',
          isLedgerActive: '1',
        })
      )
      this.$store.dispatch('setCurrentRoute', '/allModule/AdditionalTaskLite')
      this.getData()
      this.getCurrencies()
    } else {
      this.$router.push({ path: '/dashboard' })
    }
  },
  methods: {
    previousSalesView() {
      window.history.go(-1)
    },
    showAlert(msg) {
      this.alert.content = msg
      this.$refs['addPop'].open()
    },
    addInvArry() {
      this.lineADDTaskModalArray.push({
        ape_id: '',
        allModuleId: this.$sessionsStorage.get('allModuleIdMain'),
        addTask_ledgerId: '',
        addTask_amount: '',
        addTask_currency_id: '',
        addTask_remark: '',
        addTask_scCategory: '',
        addTask_selling_amt: '',
        addTask_payStatus: '',
        addTask_ledgerId_err: '',
        addTask_amount_err: '',
        addTask_currency_id_err: '',
        addTask_remark_err: '',
        addTask_scCategory_err: '',
        addTask_selling_amt_err: '',
        addTask_payStatus_err: '',
      })
    },
    removeInvArry(index) {
      this.lineADDTaskModalArray.splice(index, 1)
    },
    async removeAdditionalTask(item) {
      if (!item.ape_id) {
        this.alert.content = 'Cannot remove: Task ID not found.'
        this.$refs['addPop'].open()
        return
      }

      const ape_id = Number(item.ape_id)
      if (!ape_id || ape_id <= 0) {
        this.alert.content = 'Invalid Task ID. Please provide a valid ape_id.'
        this.$refs['addPop'].open()
        return
      }

      // Store the item to delete and show confirmation dialog
      this.itemToDelete = item
      this.confirmDelete.content = `Are you sure you want to remove this additional task? This action cannot be undone.`
      this.$refs['addPopDelete'].open()
    },
    async onCloseDeleteConfirm(type) {
      if (type !== 'cancel' && this.itemToDelete && this.itemToDelete.ape_id) {
        const ape_id = Number(this.itemToDelete.ape_id)
        if (!ape_id || ape_id <= 0) {
          this.alert.content = 'Invalid Task ID. Please provide a valid ape_id.'
          this.$refs['addPop'].open()
          this.itemToDelete = null
          return
        }

      this.isLoading = true
        try {
          const payload = {
            ape_id: ape_id,
          }

          const result = await PaymentRequestService.deletePurchaseExpense(payload)
          const { status, data } = result || {}

          if (status === 200 && data) {
            this.alert.content = (data && (data.message || data.msg)) ? (data.message || data.msg) : 'Task removed successfully'
            this.$refs['addPop'].open()
            this.getData() // Refresh the list
          } else {
            this.alert.content = 'Failed to remove task. Please try again.'
            this.$refs['addPop'].open()
          }
        } catch (e) {
          console.error('removeAdditionalTask error', e)
          this.alert.content = 'An error occurred while removing the task.'
          this.$refs['addPop'].open()
        } finally {
          this.isLoading = false
        }
      }
      this.itemToDelete = null
    },
    onRowChange() {
      // placeholder for any derived calculations later
    },
    validateRows() {
      let valid = true
      for (let j = 0; j < this.lineADDTaskModalArray.length; j++) {
        const row = this.lineADDTaskModalArray[j]
        // reset errors for this row
        row.addTask_ledgerId_err = ''
        row.addTask_amount_err = ''
        row.addTask_currency_id_err = ''
        row.addTask_scCategory_err = ''
        row.addTask_selling_amt_err = ''

        // Particulars required
        if (!row.addTask_ledgerId) {
          row.addTask_ledgerId_err = 'Particulars Field is Required'
          valid = false
        }

        // Amount required and numeric, must be greater than zero
        if (row.addTask_amount === '' || row.addTask_amount === null || row.addTask_amount === undefined) {
          row.addTask_amount_err = 'Amount Field is Required'
          valid = false
        } else if (isNaN(row.addTask_amount)) {
          row.addTask_amount_err = 'Amount must be a number'
          valid = false
        } else {
          const amount = Number(row.addTask_amount)
          if (amount <= 0) {
            row.addTask_amount_err = 'Amount must be greater than zero'
            valid = false
          }
        }

        // Currency required
        if (!row.addTask_currency_id) {
          row.addTask_currency_id_err = 'Currency is Required'
          valid = false
        }

        // Bill to Customer required
        if (!row.addTask_scCategory) {
          row.addTask_scCategory_err = 'Bill to Customer Field is Required'
          valid = false
        }

        // Selling Amount required when Bill to Customer = Yes, must be greater than zero
        if (row.addTask_scCategory === 'Yes') {
          if (row.addTask_selling_amt === '' || row.addTask_selling_amt === null || row.addTask_selling_amt === undefined) {
            row.addTask_selling_amt_err = 'Selling Amount is required when Bill to Customer is Yes'
            valid = false
          } else if (isNaN(row.addTask_selling_amt)) {
            row.addTask_selling_amt_err = 'Selling Amount must be a number'
            valid = false
          } else {
            const sellingAmt = Number(row.addTask_selling_amt)
            if (sellingAmt <= 0) {
              row.addTask_selling_amt_err = 'Selling Amount must be greater than zero'
              valid = false
            }
          }
        }
      }
      return valid
    },
    addADDTaskDetail() {
      if (!this.validateRows()) {
        // this.alert.content = 'PLEASE ENTER ALL DETAILS.'
        // this.$refs['addPop'].open()
        return
      }
      this.ADDTaskDetail.salesExeuctionNo = this.$sessionsStorage.get('JOBSERIES')
      this.ADDTaskDetail.allModuleId = this.$sessionsStorage.get('allModuleIdMain')
      // Map rows to Node model fields all_purchase_expense
      const nodeDetails = this.lineADDTaskModalArray.map((row) => ({
        ape_id: row.ape_id || undefined,
        fk_module_id: Number(this.$sessionsStorage.get('allModuleIdMain')) || undefined,
        payment_type: 2, // 2: Additional Task
        fk_ledger_id: row.addTask_ledgerId ? Number(row.addTask_ledgerId) : undefined,
        fk_currency_id: row.addTask_currency_id ? Number(row.addTask_currency_id) : undefined,
        inv_amt: row.addTask_amount !== '' ? Number(row.addTask_amount) : undefined,
        sc_category: row.addTask_scCategory || undefined,
        selling_amt: row.addTask_scCategory === 'Yes' && row.addTask_selling_amt !== '' ? Number(row.addTask_selling_amt) : undefined,
        sc_remark: row.addTask_remark || undefined,
      }))
      const submitPayload = {
        salesExeuctionNo: this.ADDTaskDetail.salesExeuctionNo,
        allModuleId: this.ADDTaskDetail.allModuleId,
        payment_type: 2,
        TaskDetails: nodeDetails,
      }

      // Submit
      this.isSubmitting = true

      PaymentRequestService.addAdditionalTask(submitPayload)
        .then((result) => {
          const { status, data } = result
          if (status === 200 && data) {
            // Adjust messaging based on Node response if available
            this.alert.content = (data && (data.message || data.msg)) ? (data.message || data.msg) : 'Saved Successfully'
            this.$refs['addPop'].open()
            window.history.go(-1)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isSubmitting = false
        })
    },
    getData() {
      this.isLoading = true
      this.lineADDTaskModalArray = []
      const nodePayload = {
        fk_module_id: Number(this.$sessionsStorage.get('allModuleIdMain')),
        payment_type: PaymentTypes.ADDITIONAL_TASK,
        is_children: 1,
        isList:0,
      }
      GlobalGetPurchaseExpense(nodePayload, (err, result) => {
        if (err) {
          this.lineADDTaskModalArray = []
          this.isLoading = false
          return
        }
        console.log("result=>", result);
        const rows = result && Array.isArray(result.raw.data) ? result.raw.data : []
        const job = result && result.raw.jobDetails ? result.raw.jobDetails : null
        this.lineADDTaskModalArray = rows.map(mapNodePurchaseExpenseToAddTaskRow)
        // Populate assignmentData from JobDetails if available
        if (job) {
          this.assignmentData = [
            {
              Job_Series: job.JobNo || this.$sessionsStorage.get('JOBSERIES') || '-',
              JobDate: job.JobDate || this.$sessionsStorage.get('JOBDATE') || '-',
              clientName: job.clientName || job.ExpClientName || job.ImpClientName || this.$sessionsStorage.get('CLIENTNAME') || '-',
              POD: job.POD || this.$sessionsStorage.get('POD') || '-',
            },
          ]
        }
        this.ADDTaskDetail.revisedMail = 0
        this.isLoading = false
      })
    },
    getCurrencies() {
      try {
        const options = { Currency: 'Currency_DropDown' }
        GlobalGetCurrencies(options, (err, list) => {
          if (err) {
            this.currencies = []
            return
          }
          this.currencies = Array.isArray(list) ? list : []
        })
      } catch (e) {
        this.currencies = []
      }
    },
  },
}
</script>

<style scoped>
.error { color: red; }

/* Polished table container with sticky header */
.table-container {
  max-height: none;
  overflow: visible;
  border-radius: 4px;
}
.table-sticky thead th {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f8f9fa;
}
.table-sticky tfoot td {
  position: sticky;
  bottom: 0;
  background: #f8f9fa;
}
.table-sticky tbody tr:hover {
  background-color: #f6fbff;
}
#add-row-btn {
  min-width: auto;
  padding: 2px 8px;
}
/* Make amount (3rd), currency (4th), action (8th) cells compact */
.table-sticky td:nth-child(3),
.table-sticky th:nth-child(3) {
  width: 110px;
}
.table-sticky td:nth-child(4),
.table-sticky th:nth-child(4) {
  width: 110px;
}
.table-sticky td:nth-child(8),
.table-sticky th:nth-child(8) {
  width: 120px;
}
.table-sticky td:nth-child(3) .form-control,
.table-sticky td:nth-child(4) .form-control {
  padding: 2px 6px;
  height: calc(1.2rem + 2px);
  font-size: 12px;
}
.table-sticky td:nth-child(8) .btn {
  padding: 2px 6px;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// AdditionalTaskLite.vue?851b0d7c